import React, { Component } from "react";

class ConfirmModal extends Component {
    render() {
        const {
            show,
            title,
            message,
            confirmText,
            cancelText,
            onConfirm,
            onCancel
        } = this.props;

        return (
            <div className={show === true ? "modal show-modal " : "modal"}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content button-box-shadow">
                        {/* Modal Header */}
                        <div className="modal-header bg-primary text-dark">
                            <h5 className="modal-title">
                                <i className="fa-solid fa-triangle-exclamation"></i>&nbsp; {title}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={onCancel}
                            ></button>
                        </div>

                        {/* Modal Body */}
                        <div className="modal-body">
                            <p className="mb-0">{message}</p>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer">                            
                            <button
                                type="button"
                                className="btn btn-danger button-box-shadow btn-sm"
                                onClick={onConfirm}
                            >
                                <i className="fa-solid fa-trash-can"></i> {confirmText}
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary button-box-shadow btn-sm"
                                onClick={onCancel}
                            >
                                <i className="fa-solid fa-circle-xmark"></i> {cancelText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmModal;
